import { FunctionComponent } from 'react';
import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import Search from '@/components/atom/icon/Search';

interface SearchButtonProps {
  onClick: () => void;
}
const SearchButton: FunctionComponent<SearchButtonProps> = ({ onClick }) => {
  return (
    <SearchButtonWrapper onClick={onClick}>
      <Search />
    </SearchButtonWrapper>
  );
};
export default SearchButton;

const SearchButtonWrapper = styled(DefaultButtonStyled)`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  &: active {
    background: ${({ theme }) => theme.color.gray50};
  }
`;
